<template>
  <div class="breadcrumb-full">
    <a-breadcrumb>
      <a-breadcrumb-item v-for="(item,index) in beadcrumbs" :key="index" :style="{'font-weight':index===beadcrumbs.length-1?'600':'400'}">
        <a v-if="item.path==='/'" @click="$router.push(item.path)" :to="item.path">{{item.title}}</a>
        <a v-else href="javascript:;">{{item.title||item.meta.title}}</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>
<script>
import {isArray} from '@/utils/javascript.util'
import {triggerWindowAddEvent} from '@/utils/util'
import {PROJECT_NAME} from '@/config/application'
// 根据路径向下查找自身

function getPositionParams(path,target,i=0,result=[]) {
  var targetPositon = get(path[i],target)
  if (!isArray(targetPositon)){
    result.push(targetPositon)
  }
  if (i===path.length-1){
    return result
  }
  if (targetPositon){
    i++;
    return getPositionParams(path,targetPositon,i,result)
  }
}
function get(path,target) {
  return target[path]
}

const DEFAULT_PATH = {
  title:PROJECT_NAME,
  path:'/'
}

export default {
  name:'breadcrumb',
  data(){
    return {
      beadcrumbs:[PROJECT_NAME]
    }
  },
  created(){
    this.initCallMenuEvent();
    this.handleBreadcrumb(this.$route,true)
  },
  methods:{
    initCallMenuEvent(){
      triggerWindowAddEvent('clickMenu',({menu})=>{this.handleBreadcrumb(menu,false)})
    },
    handleBreadcrumb(router,isCreated){
      this.updateBeadcrumbs(router)
      const {$route} = this
      let query = Object.create(null)
      if ($route.path===router.path) return;
      const isStitching = router.meta.iframePath&&$route.meta.iframePath&&$route.query['q']&&$route.query['n']&&$route.query['p']?true:false
      if (isStitching) query = $route.query
      this.$router.push({
        name:isCreated?router.meta.title:router.name,
        query
      })
    },
    updateBeadcrumbs(router){
      let processAddBeadcrumbs = getPositionParams(router.meta.position,this.usedRouter).filter(route=>route.meta.title!=="")
      this.beadcrumbs = [DEFAULT_PATH,...processAddBeadcrumbs]
    }
  },
  watch:{
    "$route":function(router){
      this.updateBeadcrumbs(router)
      this.handleBreadcrumb(router,false)
      if (router.redirectedFrom && router.redirectedFrom==='/'){
        this.$store.dispatch('setAppTitle','首页')
      }
    }
  },
  computed:{
    usedRouter(){
      return this.$store.state.application.usedRouter
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb-full{
  height: 40px;
  display: flex;
  align-items: center;
  cursor: default;
}
</style>
